import React from "react";

const ContactCompass = () => {
  return (
    <ul className="compass-links">
      <li className="compass-paragraph" style={{ listStyle: "inside" }}>
        Developer name: <span>Nigam Dudhat</span>
      </li>
      <li style={{ color: "#fff", listStyle: "inside" }}>
        <a
          href="mailto:nigamdudhat2024@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          nigamdudhat2024@gmail.com
        </a>
      </li>
    </ul>
  );
};

export default ContactCompass;
